import colorPicker from '$Stores/builderStore/modules/colorPicker';
import nightMode from '$Stores/builderStore/modules/nightMode';
import embed from '$Stores/builderStore/modules/embed';
import upsells from '$Stores/builderStore/modules/upsells';
import app from '$Stores/builderStore/modules/app';

/**
 * Default modules for builder store.
 *
 * @type {Object}
 */
const modules = {
	colorPicker,
	nightMode,
	embed,
	upsells,
	app,
};

/**
 * @module modules
 */
export default modules;
